define(function (require) {
    "use strict";

    var LE = require("app");

    // views
    var LPAuthView = require("manager-views/data-sources/integrations/authentication/types/LPAuthView");
    var OAuth2CodeView = require("manager-views/data-sources/integrations/authentication/types/OAuth2CodeView");
    var OAuth2ImplicitView = require("manager-views/data-sources/integrations/authentication/types/OAuth2ImplicitView");

    var AuthenticationTypeViewBuilder = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        var AuthViewMap = {
            0 : LPAuthView,
            1 : OAuth2ImplicitView,
            2 : OAuth2CodeView
        };

        AuthenticationTypeViewBuilder.createViewByType = function (type,options) {
            var AuthView =  AuthViewMap[type];
            if (_.isUndefined(AuthView)) {
                LEManager.logger.error("No AuthView found for type " + type,"AuthViewBuilder::createViewByType");
                LEManager.logger.graph({name: "manager:AuthViewBuilder:createViewByType:NoViewForType"});
                return "No_View_Found";
            }

            return new AuthView(options);

        };

    }

    LE.module("LEManager", moduleDefinition);

    return AuthenticationTypeViewBuilder;
});

